import { setValidateSubscription } from "./slices/userSlice";

export const validateSubscriptionAction =
  (apiInstance, role, userId) => async (dispatch) => {
    try {
      const normalizedRole = role?.toLowerCase?.();

      if (normalizedRole === "highschool") {
        return;
      }

      if (normalizedRole === "admin") {
        dispatch(setValidateSubscription(true));
        return;
      }

      let url = "";
      if (normalizedRole === "athlete") url = `/athlete/profile/${userId}`;
      else if (normalizedRole === "university") url = `/coach/profile`;

      const res = await apiInstance.get(url);
      dispatch(setValidateSubscription(!!res?.data?.hasCurrentSubscription));
    } catch (e) {
      console.error(e);
      dispatch(setValidateSubscription(false));
    }
  };
